export const parseError = (name: string, errors) => {
  if (!errors) {
    return null;
  }
  if (name.includes('.')) {
    return name.split('.').reduce((acc, curr) => acc?.[curr], errors);
  }
  return errors[name];
};
